import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { decimalToString, formatNumber } from '../../../../utils/formatNumber';
import { getUserCurrency } from '../../../../utils/user';

const LifeSummary = props => {
  const { intl, userDetails, lifeToReachData, lifeTotalCoverage, ...rest } = props;

  const currency = getUserCurrency(userDetails);
  const { reachGood, reachExcellent } = lifeToReachData || {};

  return (
    <div className="text-center cardAnalysis analysis-expansion-element analysis-total greyL6 font16" {...rest}>
      <h4 style={{ margin: '0 0 4px' }}>{intl.formatMessage({ id: 'Total life protection' })}</h4>
      <div>
        <h3 className="figureColor" style={{ margin: '0 0 4px' }}>
          {}
          {intl.formatMessage({ id: currency })} {decimalToString(lifeTotalCoverage)}{' '}
        </h3>
      </div>

      {(reachGood > 0 || reachExcellent > 0) && (
        <div>
          {reachGood > 0 && (
            <div>
              <span>
                {intl.formatMessage({
                  id: 'Top up'
                })}{' '}
              </span>

              <span className="figureColor">
                {intl.formatMessage({
                  id: currency
                })}{' '}
                {formatNumber(reachGood, intl)}{' '}
              </span>

              <span>
                {intl.formatMessage({
                  id: 'to be'
                })}{' '}
              </span>

              <span className="good-color">
                {intl.formatMessage({
                  id: 'Good'
                })}
              </span>
            </div>
          )}

          {reachExcellent > 0 && (
            <div>
              <span>
                {intl.formatMessage({
                  id: 'Top up'
                })}{' '}
              </span>

              <span className="figureColor">
                {intl.formatMessage({
                  id: currency
                })}{' '}
                {formatNumber(reachExcellent, intl)}{' '}
              </span>

              <span>
                {intl.formatMessage({
                  id: 'to be'
                })}{' '}
              </span>

              <span className="excellent-color">
                {intl.formatMessage({
                  id: 'Nice'
                })}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const container = connect(
  state => ({
    userDetails: state.user.userDetails,
    lifeToReachData: state.analysis.lifeToReachData,
    lifeTotalCoverage: state.analysis.lifeTotalCoverage
  }),
  {}
)(LifeSummary);

export default injectIntl(container);
